import _ from 'lodash';

/* @ngInject */
export default function StatusPanelController($scope, StatusPanelService, EquipmentInfoService, DashboardService) {
  const vm = this;

  vm.loadingSpinners = {
    stopStatusPanel: {}
  };
  vm.editPanel = {
    needsToBeConfigured: false
  };
  vm.statusModel = {
    currentStatuses: {},
    activeEquipment: null
  };

  vm.headerModel = {};

  vm.lengthOf = lengthOf;
  vm.setActiveEquipment = setActiveEquipment;
  vm.isOfType = isOfType;
  vm.refreshStatuses = refreshStatuses;

  vm.$onInit = checkPanelConfigurationState;

  function checkPanelConfigurationState() {
    vm.currentDashboard = DashboardService.getCurrentDashboard();
    vm.panel = vm.currentDashboard.panels[vm.panelId];
    if (vm.panel.equipment && vm.panel.equipment.length) {
      // panel is good to go
      vm.editPanel.needsToBeConfigured = false;
      init();
    } else {
      // panel needs to be configured
      vm.editPanel.needsToBeConfigured = true;
      vm.loadingSpinners.stopStatusPanel = true;
    }
  }

  function init() {
    vm.statusModel.currentStatuses = StatusPanelService.getCurrentStatuses();
    EquipmentInfoService.getFullEquipment(vm.panel.equipment)
      .then((equipment) => {
        _.forEach(equipment, (eq) => {
          vm.headerModel[eq.id] = eq;
          vm.loadingSpinners.stopStatusPanel[eq.id] = false;
          StatusPanelService.getStatusForEquipment(eq)
            .finally(() => {
              vm.loadingSpinners.stopStatusPanel[eq.id] = true;
            });
        });
        vm.statusModel.activeEquipment = equipment[0].id;
      });

    _.forEach(vm.panel.equipment, (equipmentId) => {
      $scope.$on(`event:${equipmentId}`, (__, eventObj) => {
        StatusPanelService.updateCurrentStatusFromEvent(eventObj);
      });
    });
  }


  function lengthOf(object) {
    return _.keys(object).length;
  }

  function setActiveEquipment(eq) {
    vm.statusModel.activeEquipment = eq.id;
  }

  function isOfType(value) {
    return typeof value;
  }

  function refreshStatuses() {
    vm.loadingSpinners.stopStatusPanel[vm.statusModel.activeEquipment] = false;
    StatusPanelService.getStatusForEquipment(vm.statusModel.currentStatuses[vm.statusModel.activeEquipment].equipment)
      .then((successEquipmentId) => {
        vm.loadingSpinners.stopStatusPanel[successEquipmentId] = true;
      }, (errorEquipmentId) => {
        vm.loadingSpinners.stopStatusPanel[errorEquipmentId] = true;
      });
  }

  $scope.$on('$destroy', () => {
    StatusPanelService.deleteModel(vm.panel.equipment);
  });
}
